export const dispatchPixel = (pixelName, data) => {
    const eventDetail = { detail: { pixelName, data } };
    window.dispatchEvent(new CustomEvent("pixel", eventDetail));
};
export const addPixelListener = (pixelName, listener) => 
// @ts-ignore
window.addEventListener("pixel", (event) => {
    if (event.detail.pixelName === pixelName)
        listener(event);
});
// @ts-ignore
window.addEventListener("pixel", (event) => {
    console.info(`pixel ${event.detail.pixelName}`, event.detail.data);
});
